// Generated by ts-to-zod
import { z } from 'zod';
import { paginationQuerySchema } from '../../utils/listQuery.schema';

export const rulesExecutionLogsQuerySchema = paginationQuerySchema.and(
  z.object({
    createdAtAfter: z.string().optional(),
    createdAtBefore: z.string().optional(),
    rule: z.array(z.number()).optional(),
    annotation: z.array(z.number()).optional(),
    queue: z.array(z.number()).optional(),
    requestId: z.string().optional(),
    executionResult: z.array(z.string()).optional(),
    triggerEvent: z.array(z.string()).optional(),
    triggerMatch: z.boolean().optional(),
    search: z.string().optional(),
  })
);
